import * as React from 'react';

const AppLoadingState: React.FC = () => <div id="suspense-loading-fallback" />;

export default AppLoadingState;
